import Axios from "axios";
import { getApiConfig } from "@/config/domainConfig";

Axios.withCredentials = true;
const token = localStorage.getItem("token");

// Obtenir la configuration API selon le domaine
const apiConfig = getApiConfig();

const client = Axios.create({
	baseURL: apiConfig.baseURL,
	json: true,
	headers: {
		Authorization: "Bearer " + token,
	},
});

// Pages accessibles sans être connecté : un 401 y est sans conséquence, on ne
// renvoie pas le visiteur vers le login (il n'a rien demandé d'authentifié).
// Le test porte sur la ROUTE, pas sur le domaine : padmar-performance.org sert
// à la fois l'application authentifiée et ces quelques pages publiques.
const PUBLIC_PATHS = [
	/^\/login/,
	/^\/forgot-password/,
	/^\/password\/reset/,
	/^\/portail\//,
	/^\/portal\//,
];

function isPublicPage() {
	return PUBLIC_PATHS.some((path) => path.test(window.location.pathname));
}

client.interceptors.response.use(
	function (response) {
		// Any status code that lie within the range of 2xx cause this function to trigger
		// Do something with response data
		return response;
	},
	function (error) {
		if (error.response?.status === 401 && !isPublicPage()) {
			// L'ordre compte : on purge le token AVANT de naviguer, sinon un
			// rendu intermédiaire peut le réutiliser et boucler sur un 401.
			localStorage.clear();
			window.location = '/login';
		}
		if (error.response?.status === 403) {
			// window.location = "/403";
		}
		// Any status codes that falls outside the range of 2xx cause this function to trigger
		// Do something with response error
		return Promise.reject(error);
	}
);

export default client;
